import React from 'react';

interface SectionLabelProps {
  children: React.ReactNode;
  centered?: boolean;
}

const SectionLabel: React.FC<SectionLabelProps> = ({ children, centered }) => (
  <div
    className={`flex items-center gap-[14px] mb-5 ${centered ? 'justify-center' : ''}`}
    style={{ fontSize: 9, fontWeight: 600, letterSpacing: '0.32em', textTransform: 'uppercase', color: '#b89a5a', fontFamily: 'Montserrat, sans-serif' }}
  >
    <span className="inline-block flex-shrink-0" style={{ width: 28, height: 1, background: '#b89a5a' }} />
    {children}
  </div>
);

export default SectionLabel;
